<template>
  <div class="all-bill">
    <div class="bil-top">
      <div class="txt1">剩余待结(元)</div>
      <div class="txt2">{{ notSettle }}</div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index" @click="handleJump(item.time)">
        <div class="txt-div">
          <div class="txt1">{{item.remarks}}</div>
          <div class="txt2 col1">¥{{ item.change }}</div>
        </div>
        <div class="txt-div">
          <div class="txt3">{{ item.create_time }}</div>
          <div class="txt3 col2">{{item.type_text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { finance, myNotSettleSum } from '@/api/person'
export default {
  data () {
    return {
      notSettle: '',
      list: [],
    }
  },
  mounted () {
    this.handleFun()
  },
  methods: {
    handleFun () {
      myNotSettleSum({type: 'money'}).then(res => {
        this.notSettle = res.data
      })
      finance({ type: 'money', not_settle: 1 }).then(res => {
        this.list = res.data
        console.log(this.list)
      })
    },
  }
}
</script>
<style lang="less" scoped>
.all-bill {
  padding: 20px 14px;
  box-sizing: border-box;
  min-height: 100vh;

  .bil-top {
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 114px;
    background-color: #292B2A;

    .txt1 {
      font-size: 14px;
      color: #FFFFFF;
      line-height: 14px;
      margin-bottom: 14px;
    }

    .txt2 {
      font-size: 26px;
      color: #F0E1C0;
      font-weight: 600;
      line-height: 26px;
    }
  }

  .year-txt {
    font-size: 16px;
    color: #fff;
    padding-top: 20px;
    padding-bottom: 14px;
    line-height: 16px;
  }

  .list {
    background-color: #292B2A;
    border-radius: 6px 6px 0px 0px;
    overflow: hidden;
    margin-top: 20px;

    .item {
      box-sizing: border-box;
      padding: 20px 14px;
      border-bottom: 1px solid #666666;

      &:last-child {
        border: none;
      }

      .txt-div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 16px;

        &:nth-child(1) {
          margin-bottom: 10px;
        }

        .txt1 {
          font-size: 16px;
          color: #FFFFFF;
        }

        .txt2 {
          font-size: 16px;
          color: #F0E1C0;

          &.col1 {
            color: #Fff;
          }
        }

        .txt3 {
          font-size: 12px;
          color: #999999;
          line-height: 8px;
          margin-top: 8px;

          &.col2 {
            color: #F0E1C0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/daijiesuan.vue